(function () {
  'use strict';

  var initialized = new WeakSet();
  var LS_KEY = 'sc_finder_v1';

  function loadLS() {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || '{}'); } catch (e) { return {}; }
  }
  function saveLS(obj) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(obj)); } catch (e) {}
  }
  function mergeLS(patch) {
    var s = loadLS();
    Object.keys(patch).forEach(function (k) {
      if (patch[k] !== null && patch[k] !== undefined) s[k] = patch[k];
      else delete s[k];
    });
    saveLS(s);
  }

  function initChart(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var dataEl = root.querySelector('.sc-data');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var COLUMNS = cfg.columns || [];
    var SIZES = cfg.sizes || [];

    var STRINGS = {
      selectSize: 'Select a size', unavailable: 'Unavailable',
      soldOut: 'Sold Out', addToCart: 'Add to cart',
      defaultHint: 'Select a measurement to see more details.',
      findMySize: 'Find My Size',
      noResult: 'Enter your height and weight above',
      height: 'Height', weight: 'Weight', age: 'Age',
      bestFit: 'Best fit', altFit: 'Also fits',
      estimateBtn: 'Estimate measurements',
      estimateNote: 'Estimated from your body measurements — adjust if needed'
    };
    var stringsEl = root.querySelector('.sc-strings');
    if (stringsEl) { try { Object.assign(STRINGS, JSON.parse(stringsEl.textContent)); } catch (e) {} }

    var DEFAULT_HINT = cfg.defaultHint || STRINGS.defaultHint;
    var unit = 'cm', activeIndex = null, activeCol = null;

    var headRow = root.querySelector('.sc-head');
    var tbody = root.querySelector('.sc-tbody');
    var hint = root.querySelector('.sc-hint');

    var VARIANTS = [];
    var variantsEl = root.querySelector('.sc-variants');
    if (variantsEl) { try { VARIANTS = JSON.parse(variantsEl.textContent); } catch (e) {} }

    function sizeAliases(sizeLabel) {
      var s = String(sizeLabel).trim().toLowerCase();
      // Build list of aliases: full label + part before parens + content inside parens
      // e.g. "2XL (XLG)" → ["2xl (xlg)", "2xl", "xlg"]
      var aliases = [s];
      var m = s.match(/\(([^)]+)\)/);
      if (m) {
        aliases.push(s.replace(/\s*\([^)]+\)/, '').trim());
        aliases.push(m[1].trim());
      }
      return aliases;
    }

    function isSizeOf(o, aliases) {
      return !!o && aliases.indexOf(String(o).trim().toLowerCase()) >= 0;
    }

    // DSC (Ivo 2026-10-29): the variant the shopper picked on the product page, so the chart
    // opens on that size and its button never says Sold out for a size that is in stock
    function pagePick() {
      var picked = {};
      document.querySelectorAll('[data-variant-input]').forEach(function (el) {
        if (el.type === 'radio' && !el.checked) return;
        if (!el.dataset.index || !el.value) return;
        var key = el.getAttribute('form') || '';
        (picked[key] = picked[key] || {})[el.dataset.index] = el.value;
      });
      for (var key in picked) {
        var hit = VARIANTS.filter(function (v) {
          return Object.keys(picked[key]).every(function (k) { return v[k] === picked[key][k]; });
        })[0];
        if (hit) return { variant: hit, formId: key };
      }
      var q = location.search.match(/[?&]variant=(\d+)/);
      var byUrl = q && VARIANTS.filter(function (v) { return String(v.id) === q[1]; })[0];
      return { variant: byUrl || null, formId: '' };
    }

    function pageVariant() { return pagePick().variant; }

    // DSC: Add to cart in the chart goes through the product form itself, so the page shows the same size,
    // the quantity box and the RCC members-only check apply, and the cart drawer opens as usual
    function addThroughPageForm(variant) {
      var formId = pagePick().formId;
      var form = formId && document.getElementById(formId);
      var btn = form && form.querySelector('[data-add-to-cart]');
      if (!btn) return false;
      ['option1', 'option2', 'option3'].forEach(function (k) {
        if (!variant[k]) return;
        document.querySelectorAll('[data-variant-input][data-index="' + k + '"][form="' + formId + '"]').forEach(function (el) {
          if (el.type === 'radio') { if (el.value === variant[k] && !el.checked) el.click(); }
          else if (el.tagName === 'SELECT' && el.value !== variant[k]) {
            el.value = variant[k];
            el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      var closeBtn = document.querySelector('[data-tool-tip-close]');
      if (closeBtn) closeBtn.click();
      setTimeout(function () { btn.click(); }, 60);
      return true;
    }

    function rowForVariant(variant) {
      if (!variant) return null;
      for (var i = 0; i < SIZES.length; i++) {
        var aliases = sizeAliases(SIZES[i].size);
        if ([variant.option1, variant.option2, variant.option3].some(function (o) { return isSizeOf(o, aliases); })) return i;
      }
      return null;
    }

    function findVariant(sizeLabel) {
      var aliases = sizeAliases(sizeLabel);
      var hits = VARIANTS.filter(function (v) {
        return [v.option1, v.option2, v.option3].some(function (o) { return isSizeOf(o, aliases); });
      });
      // DSC: same size in the colour picked on the page, not the first colour that has it
      var current = hits.length > 1 ? pageVariant() : null;
      if (current) {
        var sameColour = hits.filter(function (v) {
          return ['option1', 'option2', 'option3'].every(function (k) {
            return !v[k] || isSizeOf(v[k], aliases) || v[k] === current[k];
          });
        })[0];
        if (sameColour) return sameColour;
      }
      return hits[0] || null;
    }

    // DSC: a Sold out size gets the same "Sold out" line and teal Backorder request button as the product page
    function backorderUrl(variant) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!m || !(variant.price > 0)) return null;
      return '/pages/contact?view=backorder-request&product=' + m[1] + '&variant=' + variant.id;
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    }

    var atcBtn = root.querySelector('.sc-atc .add-to-cart');
    var atcText = root.querySelector('.sc-atc-text');
    var soldOutLabel = null;
    if (atcBtn) {
      soldOutLabel = document.createElement('p');
      soldOutLabel.className = 'sc-soldout-label';
      soldOutLabel.textContent = 'Sold out';
      soldOutLabel.hidden = true;
      atcBtn.parentNode.insertBefore(soldOutLabel, atcBtn);
    }

    function updateAtcButton() {
      if (!atcBtn) return;
      atcBtn.classList.remove('sc-atc--backorder');
      delete atcBtn.dataset.backorderUrl;
      soldOutLabel.hidden = true;
      if (activeIndex === null) { atcBtn.disabled = true; atcText.textContent = STRINGS.selectSize; return; }
      var variant = findVariant(SIZES[activeIndex].size);
      if (!variant) { atcBtn.disabled = true; atcText.textContent = STRINGS.unavailable; return; }
      atcBtn.dataset.variantId = variant.id;
      if (!variant.available) {
        var url = backorderUrl(variant);
        if (url) {
          atcBtn.disabled = false;
          atcBtn.dataset.backorderUrl = url;
          atcBtn.classList.add('sc-atc--backorder');
          soldOutLabel.hidden = false;
          atcText.textContent = 'Backorder request';
          return;
        }
        atcBtn.disabled = true; atcText.textContent = 'Sold out'; return;
      }
      atcBtn.disabled = false;
      atcText.textContent = STRINGS.addToCart + ' - ' + formatMoney(variant.price);
    }

    function toIn(v) { return Math.round(v / 2.54); }
    function fmtVal(v) {
      if (v == null) return '—';
      if (Array.isArray(v)) return unit === 'cm' ? v[0] + ' - ' + v[1] : toIn(v[0]) + ' - ' + toIn(v[1]);
      if (typeof v === 'object') return v[unit] || v.cm || '—';
      return String(v);
    }

    var FIGURES = {};
    var figuresEl = root.querySelector('.sc-figures');
    if (figuresEl) { try { FIGURES = JSON.parse(figuresEl.textContent); } catch (e) {} }

    var figureEl = root.querySelector('.sc-figure');
    var svgEl = root.querySelector('.sc-svg');
    var bodyEl = root.querySelector('.sc-body');

    // Replace SVG with product-specific image if cfg.figure matches
    var figureImgUrl = cfg.figure ? (FIGURES[cfg.figure] || null) : null;
    if (figureImgUrl && svgEl) {
      svgEl.innerHTML = '<img src="' + figureImgUrl + '" alt="">';
    }

    // Hide SVG bars that have no corresponding column in this chart
    root.querySelectorAll('[data-bar]').forEach(function (barEl) {
      var hasMatch = COLUMNS.some(function (c) { return c.bar === barEl.dataset.bar; });
      barEl.style.display = hasMatch ? '' : 'none';
    });

    var hasFigure = figureImgUrl !== null || COLUMNS.some(function (col) {
      return col.bar && !!root.querySelector('[data-bar="' + col.bar + '"]');
    });
    if (!hasFigure && figureEl) {
      figureEl.style.display = 'none';
      if (bodyEl) bodyEl.style.gridTemplateColumns = '1fr';
    }

    function initHeader() {
      headRow.innerHTML = '<th>Size</th>' + COLUMNS.map(function (c) { return '<th>' + c.label + '</th>'; }).join('');
    }

    function updateMeasurement() {
      COLUMNS.forEach(function (col) {
        var bar = root.querySelector('[data-bar="' + col.bar + '"]');
        if (bar) bar.classList.toggle('active', col.key === activeCol);
      });
      var col = COLUMNS.filter(function (c) { return c.key === activeCol; })[0];
      if (col && col.desc) { hint.textContent = col.desc; hint.classList.remove('muted'); }
      else { hint.textContent = DEFAULT_HINT; hint.classList.add('muted'); }
      updateAtcButton();
    }

    function render() {
      tbody.innerHTML = '';
      SIZES.forEach(function (row, i) {
        var tr = document.createElement('tr');
        if (i === activeIndex) tr.classList.add('active');
        var sizeTd = document.createElement('td');
        sizeTd.dataset.col = '';
        sizeTd.textContent = row.size;
        if (i === activeIndex && activeCol === null) sizeTd.classList.add('cell-active');
        tr.appendChild(sizeTd);
        COLUMNS.forEach(function (col) {
          var td = document.createElement('td');
          td.dataset.col = col.key;
          if (i === activeIndex && col.key === activeCol) td.classList.add('cell-active');
          td.textContent = fmtVal(row.values[col.key]);
          tr.appendChild(td);
        });
        tr.addEventListener('click', function (e) {
          e.stopPropagation();
          var cell = e.target.closest('td');
          activeIndex = i; activeCol = cell ? (cell.dataset.col || null) : null;
          updateMeasurement(); render();
        });
        tbody.appendChild(tr);
      });
    }

    function estimateFromBody(heightCm, weightKg, age) {
      var dH = heightCm - 175, dW = weightKg - 75;
      var ageFactor = Math.max(0, age - 25) * 0.12;
      return {
        height:   Math.round(heightCm),
        weight:   Math.round(weightKg),
        chest:    Math.round(95 + dH * 0.42 + dW * 0.60),
        bust:     Math.round(95 + dH * 0.42 + dW * 0.60),
        waist:    Math.round(82 + dH * 0.30 + dW * 0.85 + ageFactor),
        hip:      Math.round(98 + dH * 0.44 + dW * 0.55),
        seat:     Math.round(98 + dH * 0.44 + dW * 0.55),
        length:   Math.round(72 + dH * 0.38),
        torso:    Math.round(72 + dH * 0.38),
        inseam:   Math.round(78 + dH * 0.46),
        shoulder: Math.round(44 + dH * 0.20 + dW * 0.05)
      };
    }

    function findEstimate(colKey, estimates) {
      var k = colKey.toLowerCase();
      for (var key in estimates) {
        if (k.indexOf(key) >= 0) return estimates[key];
      }
      return null;
    }

    // Only include columns that are both numeric AND can be estimated from body measurements
    var _refEst = estimateFromBody(175, 75, 30);
    var finderCols = COLUMNS.filter(function (col) {
      var hasNumeric = SIZES.some(function (row) {
        var v = row.values[col.key];
        return Array.isArray(v) || (v && typeof v === 'object' && ('cm' in v || 'in' in v));
      });
      return hasNumeric && findEstimate(col.key, _refEst) !== null;
    });

    var hasCmIn = COLUMNS.some(function (col) {
      return SIZES.some(function (row) {
        var v = row.values[col.key];
        return v && typeof v === 'object' && ('cm' in v) && ('in' in v);
      });
    });

    // No estimable columns → hide Find My Size tab
    if (!finderCols.length) {
      var finderTab = root.querySelector('.sc-tab[data-tab="finder"]');
      if (finderTab) finderTab.style.display = 'none';
    }
    // No cm/in values at all → hide unit toggle
    if (!hasCmIn) {
      var unitToggle = root.querySelector('.sc-unit');
      if (unitToggle) unitToggle.style.display = 'none';
    }

    function initTabs() {
      var unitEl = root.querySelector('.sc-unit');
      var footerResult = root.querySelector('.sc-footer-result');

      root.querySelectorAll('.sc-tab').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var tab = btn.dataset.tab;
          root.querySelectorAll('.sc-tab').forEach(function (b) { b.classList.toggle('active', b.dataset.tab === tab); });
          root.querySelectorAll('.sc-panel').forEach(function (p) { p.classList.toggle('sc-panel--hidden', p.dataset.panel !== tab); });
          // cm/in toggle: only visible on the chart tab
          if (unitEl) unitEl.classList.toggle('sc-section--hidden', tab === 'finder');
          // Size suggestion: only visible on the finder tab
          if (footerResult) footerResult.classList.toggle('sc-section--hidden', tab !== 'finder');
        });
      });
    }

    // --- Size matching (always in cm) ---

    function parseRangeStr(str) {
      var parts = String(str).replace(/\s/g, '').split('-').map(Number);
      return parts.length >= 2 ? [parts[0], parts[1]] : [parts[0], parts[0]];
    }

    function getRange(v) {
      if (v == null) return null;
      var str;
      if (Array.isArray(v)) { str = v[0] + '-' + v[1]; }
      else if (typeof v === 'object') { str = v.cm || null; }
      else { return null; }
      if (!str) return null;
      var r = parseRangeStr(str);
      return (isNaN(r[0]) || isNaN(r[1])) ? null : r;
    }

    function distToRange(x, range) {
      if (x < range[0]) return range[0] - x;
      if (x > range[1]) return x - range[1];
      return 0;
    }

    function calcTopMatches(inputs, n) {
      var keys = Object.keys(inputs).filter(function (k) { return inputs[k] !== null; });
      if (!keys.length) return [];
      var scores = [];
      SIZES.forEach(function (row, i) {
        var totalDist = 0, valid = true;
        keys.forEach(function (k) {
          var range = getRange(row.values[k]);
          if (!range) { valid = false; }
          else { totalDist += distToRange(inputs[k], range); }
        });
        if (valid) scores.push({ idx: i, dist: totalDist });
      });
      scores.sort(function (a, b) { return a.dist - b.dist || a.idx - b.idx; });
      return scores.slice(0, n).map(function (s) { return s.idx; });
    }

    // Render size suggestion cards into the sticky footer
    function updateFinderResult(panel, keepPick) {
      var resultEl = root.querySelector('.sc-footer-result');
      if (!resultEl) return;
      if (!panel) panel = root.querySelector('.sc-panel[data-panel="finder"]');

      var inputs = {};
      if (panel) {
        panel.querySelectorAll('.sc-meas-input').forEach(function (input) {
          var v = parseFloat(input.value);
          if (!isNaN(v)) inputs[input.dataset.col] = v;
        });
      }

      var topIdxs = calcTopMatches(inputs, 2);
      if (!topIdxs.length) {
        resultEl.innerHTML = '';
        if (activeIndex !== null && !keepPick) { activeIndex = null; updateAtcButton(); }
        return;
      }

      if (activeIndex !== topIdxs[0] && activeIndex !== topIdxs[1] && !(keepPick && activeIndex !== null)) {
        activeIndex = topIdxs[0];
        updateAtcButton();
      }

      var html = '<div class="sc-finder-matches">';
      topIdxs.forEach(function (idx, rank) {
        var isActive = idx === activeIndex;
        html += '<button type="button" class="sc-finder-match-btn' + (isActive ? ' active' : '') + '" data-idx="' + idx + '">';
        html += '<span class="sc-finder-match-rank">' + (rank === 0 ? STRINGS.bestFit : STRINGS.altFit) + '</span>';
        html += '<strong class="sc-finder-match-size">' + SIZES[idx].size + '</strong>';
        html += '</button>';
      });
      html += '</div>';
      resultEl.innerHTML = html;

      resultEl.querySelectorAll('.sc-finder-match-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          activeIndex = parseInt(btn.dataset.idx, 10);
          updateAtcButton();
          resultEl.querySelectorAll('.sc-finder-match-btn').forEach(function (b) {
            b.classList.toggle('active', b === btn);
          });
        });
      });
    }

    function saveMeasToLS(panel) {
      var meas = {};
      panel.querySelectorAll('.sc-meas-input').forEach(function (input) {
        var v = parseFloat(input.value);
        if (!isNaN(v)) meas[input.dataset.col] = v;
      });
      mergeLS({ measurements: meas });
    }

    function initFinder() {
      var panel = root.querySelector('.sc-panel[data-panel="finder"]');
      if (!panel || !finderCols.length) return;

      var saved = loadLS();
      var savedMeas = saved.measurements || {};
      var hasMeas = finderCols.some(function (c) { return savedMeas[c.key] != null; });

      var html = '<div class="sc-finder">';

      // Body inputs + estimate button all in one grid row
      html += '<div class="sc-finder-inputs sc-body-inputs">';
      html += '<div class="sc-finder-field"><label class="sc-finder-label">' + STRINGS.height + ' <span class="sc-finder-unit">(cm)</span></label>';
      html += '<input type="number" class="sc-finder-input sc-input-height" min="0" step="1" placeholder="—" value="' + (saved.height != null ? saved.height : '') + '"></div>';
      html += '<div class="sc-finder-field"><label class="sc-finder-label">' + STRINGS.weight + ' <span class="sc-finder-unit">(kg)</span></label>';
      html += '<input type="number" class="sc-finder-input sc-input-weight" min="0" step="1" placeholder="—" value="' + (saved.weight != null ? saved.weight : '') + '"></div>';
      html += '<div class="sc-finder-field"><label class="sc-finder-label">' + STRINGS.age + '</label>';
      html += '<input type="number" class="sc-finder-input sc-input-age" min="0" step="1" placeholder="—" value="' + (saved.age != null ? saved.age : '') + '"></div>';
      // Button as 4th cell, flush to bottom of cell via justify-content: flex-end
      html += '<div class="sc-finder-field sc-estimate-field">';
      html += '<button type="button" class="sc-estimate-btn">' + STRINGS.estimateBtn + '</button></div>';
      html += '</div>';

      // Editable measurement inputs (only finderCols, hidden until estimate)
      html += '<div class="sc-meas-section' + (hasMeas ? '' : ' sc-section--hidden') + '">';
      html += '<p class="sc-estimate-note">' + STRINGS.estimateNote + '</p>';
      html += '<div class="sc-finder-inputs sc-meas-inputs">';
      finderCols.forEach(function (col) {
        var val = savedMeas[col.key] != null ? savedMeas[col.key] : '';
        html += '<div class="sc-finder-field">';
        html += '<label class="sc-finder-label">' + col.label + ' <span class="sc-finder-unit">(cm)</span></label>';
        html += '<input type="number" class="sc-finder-input sc-meas-input" data-col="' + col.key + '" min="0" step="1" placeholder="—" value="' + val + '">';
        html += '</div>';
      });
      html += '</div></div>';

      html += '</div>';
      panel.innerHTML = html;

      var measSection = panel.querySelector('.sc-meas-section');

      // Estimate button
      panel.querySelector('.sc-estimate-btn').addEventListener('click', function (e) {
        e.stopPropagation();
        var hv = parseFloat(panel.querySelector('.sc-input-height').value);
        var wv = parseFloat(panel.querySelector('.sc-input-weight').value);
        var av = parseFloat(panel.querySelector('.sc-input-age').value);
        if (isNaN(hv) || isNaN(wv)) return;
        var est = estimateFromBody(hv, wv, isNaN(av) ? 30 : av);
        panel.querySelectorAll('.sc-meas-input').forEach(function (input) {
          var v = findEstimate(input.dataset.col, est);
          if (v !== null) input.value = v;
        });
        measSection.classList.remove('sc-section--hidden');
        saveMeasToLS(panel);
        updateFinderResult(panel);
      });

      // Measurement inputs: update on edit
      panel.querySelectorAll('.sc-meas-input').forEach(function (input) {
        input.addEventListener('input', function (e) {
          e.stopPropagation();
          saveMeasToLS(panel);
          updateFinderResult(panel);
        });
      });

      // Body inputs: persist to localStorage
      ['height', 'weight', 'age'].forEach(function (field) {
        var el = panel.querySelector('.sc-input-' + field);
        if (!el) return;
        el.addEventListener('input', function (e) {
          e.stopPropagation();
          var v = parseFloat(el.value);
          var patch = {};
          patch[field] = !isNaN(v) ? v : null;
          mergeLS(patch);
        });
      });

      // Auto-run matching if saved measurements exist (result hidden until user opens finder tab).
      // DSC: the size picked on the page stays selected; Best fit only takes over when the shopper uses Find My Size.
      if (hasMeas) updateFinderResult(panel, true);
    }

    function initFit() {
      var panel = root.querySelector('.sc-panel[data-panel="fit"]');
      if (!panel) return;

      var dataEl = root.querySelector('.sc-data-fit-tabs');
      if (!dataEl) return;

      var fitDatas;
      try { fitDatas = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var imgUrl = STRINGS.productImg ?? '';

      var html = '<div class="sc-fit">';
      
      // Image
      html += '<div class="sc-fit-image">'
      html += '<img src="' + imgUrl + '" alt="product" width="300" height="300" style="max-width: 100%; height: auto;">';
      html += '</div>';

      // Content
      html += '<div class="sc-fit-contents">'
      // Tabs
      html += '<div class="sc-fit-tabs flex gap-4 mb-4">';
      html += '<div class="sc-fit-super-aero-field sc-fit-tab"><span class="sc-fit-super-aero uppercase">Super Aero</span></div>';
      html += '<div class="sc-fit-racing-field sc-fit-tab"><span class="sc-fit-racing uppercase">Racing</span></div>';
      html += '<div class="sc-fit-regular-field sc-fit-tab"><span class="sc-fit-regular uppercase">Regular</span></div>';
      html += '<div class="sc-fit-comfort-field sc-fit-tab"><span class="sc-fit-comfort uppercase">Comfort</span></div>';
      html += '</div>';

      // Tabs contents
      if (Array.isArray(fitDatas)) {
        fitDatas.forEach(tab => {
          html += `<div class="sc-fit-${tab.tab_label.toLowerCase().replace(/\s+/g, "-")}-field-content hidden">`;
          html += `<p class="title">${tab.tab_title}</p>`;
          html += `<p>${tab.tab_content}</p>`;
          html += `<p class="content-footer">${tab.tab_footer}</p>`;
          html += `</div>`;
        });
      }

      html += '</div>';
      html += '</div>';
      
      panel.innerHTML = html;

      var availableTabs = '';
      if (Array.isArray(fitDatas)) {
         availableTabs = fitDatas.map(tab =>
          tab.tab_label.toLowerCase().replace(/\s+/g, "-")
        );
      }
      const tabs = panel.querySelectorAll(".sizechart .sc-fit-tabs .sc-fit-tab");

      tabs.forEach(tab => {
        const slug = tab.classList[0]
          .replace("sc-fit-", "")
          .replace("-field", "");

        if (!availableTabs.includes(slug)) {
          tab.classList.add("disabled");
          return;
        }
        tab.addEventListener("click", function () {
          tabs.forEach(t => t.classList.remove("active"));
          panel.querySelectorAll('[class$="-field-content"]').forEach(content => {
            content.classList.add("hidden");
          });
          const contentClass = `${tab.classList[0]}-content`;
          const content = panel.querySelector(`.${contentClass}`);

          if (content) {
            content.classList.remove("hidden");
          }
          tab.classList.add("active");
        });
      });

      // show first tab when open Fit tab
      if (Array.isArray(fitDatas)) {
        if (fitDatas.length) {
          const firstSlug = fitDatas[0].tab_label.toLowerCase().replace(/\s+/g, "-");

          panel.querySelector(`.sc-fit-${firstSlug}-field`)?.classList.add("active");
          panel.querySelector(`.sc-fit-${firstSlug}-field-content`)?.classList.remove("hidden");
        }
      }
    }

    const tabs = root.querySelectorAll(".sizechart .sc-tab");
    const scAtc = root.querySelector(".sizechart .sc-atc");
    const scFms = root.querySelector(".sizechart .sc-fms");
    const scUnit = root.querySelector(".sizechart .sc-top-right");

    // Toggle Find My Size button - only visible on Fit tab
    function updateFooter(tab) {
      if (tab === "fit") {
        scAtc.classList.add("hidden");
        scUnit.classList.add("hidden");
        scFms.classList.remove("hidden");
      } else {
        scAtc.classList.remove("hidden");
        scUnit.classList.remove("hidden");
        scFms.classList.add("hidden");
      }
    }

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        updateFooter(tab.dataset.tab);
      });
    });

    const activeTab = document.querySelector(".sc-tab.active");
    if (activeTab) {
      updateFooter(activeTab.dataset.tab);
    }

    // Click Find My Size on Fit tab
    scFms.addEventListener("click", () => {
      root.querySelector('.sc-tab[data-tab="finder"]')?.click();
    });

    // Unit toggle — only visible on chart tab (initTabs controls this)
    var switchBtn = root.querySelector('.sc-switch');
    if (switchBtn) {
      switchBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        unit = unit === 'cm' ? 'in' : 'cm';
        switchBtn.classList.toggle('cm', unit === 'cm');
        var uCm = root.querySelector('.sc-u-cm');
        var uIn = root.querySelector('.sc-u-in');
        if (uCm) uCm.classList.toggle('on', unit === 'cm');
        if (uIn) uIn.classList.toggle('on', unit === 'in');
        render();
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (atcBtn.dataset.backorderUrl) { window.location.href = atcBtn.dataset.backorderUrl; return; }
        var id = parseInt(atcBtn.dataset.variantId, 10);
        var picked = id && VARIANTS.filter(function (v) { return v.id === id; })[0];
        if (picked && addThroughPageForm(picked)) return;
        if (!id) return;
        atcBtn.disabled = true;
        atcBtn.classList.add('btn--loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(function () {
          atcBtn.classList.remove('btn--loading');
          var closeBtn = document.querySelector('[data-tool-tip-close]');
          if (closeBtn) closeBtn.click();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }).catch(function () {
          atcBtn.classList.remove('btn--loading');
          atcBtn.disabled = false;
        });
      });
    }

    activeIndex = rowForVariant(pageVariant());

    initHeader();
    render();
    updateAtcButton();
    initTabs();
    initFinder();
    initFit();
  }

  // DSC (Ivo 2026-10-29): same "Sold out" line and teal Backorder request button as the product page
  function addStyles() {
    if (document.getElementById('sc-dsc-styles')) return;
    var st = document.createElement('style');
    st.id = 'sc-dsc-styles';
    st.textContent =
      '.sizechart .sc-soldout-label{margin:0 0 10px;padding-left:24px;font-size:1rem;font-weight:600;line-height:1.3;text-align:left}' +
      '.sizechart .sc-soldout-label[hidden]{display:none}' +
      '.sizechart .sc-atc .add-to-cart.sc-atc--backorder{background:#00E6C4!important;border-color:#00E6C4!important;color:#1f1f1f!important;opacity:1}' +
      '.sizechart .sc-atc .add-to-cart.sc-atc--backorder:hover,.sizechart .sc-atc .add-to-cart.sc-atc--backorder:focus-visible{background:transparent!important;color:#00E6C4!important}';
    document.head.appendChild(st);
  }
  addStyles();

  function initAll(ctx) { (ctx || document).querySelectorAll('.sizechart').forEach(initChart); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('sizechart')) initChart(node);
        if (node.querySelectorAll) node.querySelectorAll('.sizechart').forEach(initChart);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
